import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as userActions from "../../../../actions/user.actions";
import * as commonActions from "../../../../actions/common.actions";
import * as projectActions from "../../../../actions/project.actions";

import CompanyPaymentAddCard from "../components/CompanyPaymentAddCard";

class CompanyPaymentAddCardContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      revalidate: {
        number: false,
        name: false,
        ccv: false,
        expiration_date: false
      }
    };
  }

  componentDidMount() {
    this.props.projectActions.getProjects();
  }

  componentWillUnmount() {
    this.removeErrors();
  }

  removeErrors() {
    this.props.commonActions.showError(null);
  }

  revalidateField() {
    if (this.props.commonError != null) {
      this.setState({
        revalidate: {
          number: true,
          name: true,
          ccv: true,
          expiration_date: true
        }
      });
    }
  }

  handleSubmit(data) {
    this.props.actions.verifyAccount(data);

    if (this.props.commonError) {
      this.setState({
        revalidate: {
          number: false,
          name: false,
          ccv: false,
          expiration_date: false
        }
      });
    }
  }

  render() {
    const { number, name, ccv, expiration_date } = this.state.revalidate;

    return (
      <CompanyPaymentAddCard
        onSubmit={this.handleSubmit.bind(this)}
        removeErrors={this.removeErrors.bind(this)}
        revalidateField={this.revalidateField.bind(this)}
        forceError={this.props.commonError}
        revalidate={{ number, name, ccv, expiration_date }}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    projectCount: state.project.projects.length,
    commonError: state.common.error,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(userActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyPaymentAddCardContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/payment/containers/CompanyPaymentAddCardContainer.js